<select [ngModel]="selection" (ngModelChange)="changed($event);" [ngStyle]="{width: getWidth()}" title="Choose Action">
  <option [value]="null" hidden>Action</option>
  <ng-template ngFor let-o [ngForOf]="options" let-i="index">
      <option *ngIf="isVisible(o)"  [secure]="o.security" [value]="i">{{o.title}}</option>
  </ng-template>
</select>

